<template>
    <Paper class="dayAssessHead-box">
        <div class="top">
            <div class="top" style="overflow-x:scroll">
                <div class="top-box" v-for="(itme,i) in headArr" :key="i">
                    <div class="font-w">{{itme.quotaName}}</div>
                    <div class="top-box-item">
                        <div class="box-item">
                            <div>数量</div>
                            <div class="font-w">{{itme.totalNumber || 0}}</div>
                        </div>
                        <div class="box-item m-l">
                            <div>考核金额</div>
                            <div class="font-w color-f40">{{itme.fineAmount || 0}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="top-box end-box">
                <div class="font-w">日常考核总额（元）</div>
                <div class="top-box-item">
                    <div class="box-item">
                        <div class="font-w color-f40">{{totalAmount}}</div>
                    </div>
                </div>
            </div>
        </div>
        <daylyAssessmentSup @backreset="backreset"></daylyAssessmentSup>
    </Paper>
</template>

<script>
import Paper from '@/components/core/paper/Paper';
import daylyAssessmentSup from './daylyAssessmentSup.vue';
import { customerDailyHeader } from '../../../lsrm/api/achievements/daylyAssessment.js';
export default {
    data() {
        return {
            headArr: [],
            totalAmount: ''
        };
    },
    components: { Paper, daylyAssessmentSup },
    mounted() {
    },
    methods: {
        backreset(par) {
            this.customerDailyHeaderFunc(par);
        },
        customerDailyHeaderFunc(par) {
            customerDailyHeader(par).then(res => {
                if (res && +res.code === 0) {
                    this.headArr = res.data;
                    this.totalAmount = res.data.length > 0 ? (res.data[0].totalAmount || 0) : 0;
                }
            });
        }
    }

};
</script>

<style lang="less">
.dayAssessHead-box {
    font-size: 14px;
    min-height: calc(~"100vh - 72px");
    background: #f6f8fa;
    padding: 0;
    box-shadow: initial;
    margin: 10px;
    .top {
        display: flex;
        width: 100%;
        .top-box {
            background: #fff;
            padding: 20px;
            width: 500px;
            flex-shrink: 0;
            border-right:1px solid #f4f4f4 ;
        }
        .top-box-item {
            display: flex;
        }
        .box-item {
            width: 100%;
            background: #f4f4f4;
            margin-top: 10px;
            border-radius: 2px ;
            padding: 10px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .m-l {
            margin-left: 10px;
        }
        .color-f40 {
            color: #ff6600;
        }
        .end-box {
            flex-shrink: 0;
            width: 240px;
        }

    }
    .font-w{
        font-weight: 700;font-size: 16px;
    }
    ::-webkit-scrollbar-track {
        background-color: #fff;
    }
}
</style>